<template>
  <div class="payment-succ" style='background: #5927FF' :class="{'rtl': locale === 'ar'}">
    <div class="logo-ps">
    <img src="../assets/images/logo_white.svg" alt="">
    </div>
    <p>Redirecting to policy page</p>
    <div class="loader-ic">
      <v-lottie-player
        name="scooterAnim"
        loop
        autoplay
        path="https://assets2.lottiefiles.com/packages/lf20_eqfp0yvw.json"
        style="width: 103px; height: 103px;"
        background="transparent"
      />
    </div>
    <p dir="rtl" style="font-family: 'URWGeometricArabic';">إعادة التوجيه
      إلى صفحة الوثيقة </p>
  </div>
</template>

<script>
export default {
  name: 'PaymentRedirectLoader',
  components: {
    vLottiePlayer: () => import('vue-lottie-player')
  },
  computed: {
    locale () {
      return this.$i18n.locale
    }
  }
}
</script>
